import Vue from 'vue'
import Buefy from 'buefy'
import PasswordReset from './App.vue'

Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

Vue.use(PasswordReset)

if(document.getElementById("resetPasswordApp")){
    new Vue({
        render:h=>h(
            PasswordReset,{
                props:{
                    logo:document.getElementById("resetPasswordApp")
                        .getAttribute("logo"),
                    resetUrl:document.getElementById("resetPasswordApp")
                        .getAttribute("reset-url")
                }
            }
        )
    }).$mount("#resetPasswordApp")
}